module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/pancreas-0acc4068ceef6bcd661f7eeb791d08a5.png";